import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';
import NumeralService from '/@/modules/core/app/services/NumeralService';

export class TaxColumn extends BaseModel {
  /**
   * @var {string}
   */
  name;

  /**
   * @var {float}
   */
  value;

  /**
   * @var {string}
   */
  dataType;

  /**
   * @var {string}
   */
  formula;

  constructor(model = {}) {
    super();
    this.name = model.name;
    this.value = model.value;
    this.dataType = model.dataType;
    this.formula = model.formula;
  }

  get formattedValue() {
    return NumeralService.formatValue(this.value, ColumnFormat.FORMAT_CURRENCY, 2);
  }

  get formattedFormula() {
    return this.formula ? `${this.formula} =` : null;
  }
}
